export enum IconSetType {
    Static = 1,
    Animated = 2,
}